import React, { useEffect } from "react"

import { AcrissAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { isEmpty } from "@ui-seeker/utils"


export default function ReportExtrasAcrissField() {

	const {
		filterAcriss,
		setFilterAcrissInfo,
		error,
	} = useReportFormInfo(reportFormData.peek().filterAcriss, "filterAcriss", object({ filterAcriss: array().required("Must provide an acriss code").min(1, "Must provide an acriss code") }))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setFilterAcrissInfo([], false)
		}
	}, [])

	return <AcrissAutocomplete
		value={filterAcriss || []}
		onChange={e => setFilterAcrissInfo(e.target.value)}
		error={error}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/acriss`}
	/>
}